import './Online.css';
const onlinePeople = '520 онлайн';

export const Online = () => {
    return (
        <div className="online">
            <span className="online__text">{onlinePeople}</span>
            <svg className="online__icon" xmlns="http://www.w3.org/2000/svg" width="17" height="16">
                <g fill="none">
                    <circle cx="8.01" cy="7.894" r="1.333" fill="#605F68" />
                    <path
                        fill="#7E8487"
                        d="M5.184 11.227a1 1 0 0 1-.769-.36 4.657 4.657 0 0 1-.002-5.945.999.999 0 1 1 1.54 1.276 2.653 2.653 0 0 0-.001 3.388 1 1 0 0 1-.768 1.64zm5.652 0a.999.999 0 0 1-.768-1.64 2.653 2.653 0 0 0-.002-3.389 1 1 0 0 1 1.541-1.275 4.657 4.657 0 0 1-.002 5.945.999.999 0 0 1-.769.359z"
                    />
                    <path
                        fill="#F1F1F1"
                        d="M13.503 13.227a1 1 0 0 1-.783-1.62 5.957 5.957 0 0 0 0-7.426 1 1 0 1 1 1.568-1.241 7.947 7.947 0 0 1 0 9.908.998.998 0 0 1-.785.379zm-10.985 0a.999.999 0 0 1-.785-.38 7.947 7.947 0 0 1 0-9.907 1 1 0 1 1 1.568 1.24 5.957 5.957 0 0 0 0 7.426 1 1 0 0 1-.783 1.62z"
                        opacity=".6"
                    />
                </g>
            </svg>
            <span className="online__text">все свои</span>
        </div>
    );
};
